import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Box, TextField } from '@mui/material';
import CustomDialog from '../../../../Components/Dialog/CustomDialog';

const SystemParametersDialog = function SystemParametersDialog({
  open,
  handleClose,
  onSubmit,
  settings,
  title,
  dialogId,
  existingNames = [],
}) {
  const intl = useIntl();

  const [settingName, setSettingName] = useState('');
  const [settingValue, setSettingValue] = useState('');
  const [description, setDescription] = useState('');
  const [editSetting, setEditSetting] = useState(false);

  useEffect(() => {
    if (open && dialogId === 'editSetting') {
      setSettingName(settings.settingName);
      setSettingValue(settings.settingValue);
      setDescription(settings.description ?? '');
      setEditSetting(true);
    }
  }, [open, dialogId]);

  // Checked against every parameter, not the ones the search leaves in the list.
  const nameTaken =
    !editSetting &&
    existingNames.some(
      (name) => name?.trim().toUpperCase() === settingName?.trim().toUpperCase()
    );

  // The description is optional, as in the table; an edit saves only a change.
  const unchanged =
    editSetting &&
    settingValue === settings?.settingValue &&
    (description || '') === (settings?.description || '');

  const handleSettingNameChange = (e) => {
    setSettingName(e.target.value);
  };

  const handleSettingValueChange = (e) => {
    setSettingValue(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleSubmit = () => {
    onSubmit({
      settingName,
      settingValue,
      description: description || null,
    });
  };
  const reset = () => {
    setSettingName('');
    setSettingValue('');
    setDescription('');
    setEditSetting(false);
  };

  return (
    <CustomDialog
      title={title}
      open={open}
      close={(_, reason) => {
        if (reason !== 'clickaway' && reason !== 'escapeKeyDown') {
          handleClose();
          reset();
        }
      }}
      notRequiredFields
      messageDialog
      maxWidth="sm"
      fullWidth
      onSubmit={() => {
        handleSubmit();
        reset();
      }}
      submitDisabled={!(settingName && settingValue) || nameTaken || unchanged}
      noBackdrop
      noForm
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          gap: '24px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '16px',
            width: '100%',
          }}
        >
          {editSetting !== true && (
            <TextField
              id="settingName-txtField"
              onChange={handleSettingNameChange}
              label={intl.messages.NAME}
              required
              value={settingName}
              error={nameTaken}
              helperText={
                nameTaken ? intl.messages.EXISTING_SYSTEM_PARAMETER : undefined
              }
              sx={{ width: '100%' }}
            />
          )}
          <TextField
            id="settingValue-txtField"
            onChange={handleSettingValueChange}
            label={intl.messages.VALUE}
            required
            multiline
            maxRows={8}
            value={settingValue}
            sx={{ width: '100%' }}
          />
        </Box>
        <TextField
          id="description-txtField"
          onChange={handleDescriptionChange}
          label={intl.messages.DESCRIPTION}
          multiline
          minRows={2}
          value={description}
        />
      </Box>
    </CustomDialog>
  );
};

export default SystemParametersDialog;
